import { isCancelled, policyStatus, type StatusFields } from '@/lib/policy';
import { cn } from '@/lib/utils';

/** A policy's state as the list names it: Active, Inactive or Cancelled. */
export const policyStatusLabel = (policy: StatusFields) => policyStatus(policy);

/** A policy's state as the list shows it: a coloured dot and ACTIVE, INACTIVE or CANCELLED. */
export function PolicyStatus({ payoutsEnabled, canceledAt }: StatusFields) {
  const cancelled = isCancelled({ canceledAt });
  const label = policyStatus({ payoutsEnabled, canceledAt });
  const color = cancelled ? 'text-status-cancelled' : payoutsEnabled ? 'text-status-active' : 'text-status-inactive';
  const dot = cancelled ? 'bg-status-cancelled' : payoutsEnabled ? 'bg-status-active' : 'bg-status-inactive';
  return (
    <span className="inline-flex items-center gap-3">
      <span aria-hidden className={cn('size-2.5 rounded-full', dot)} />
      <span className={cn('pt-0.5 text-xs font-semibold uppercase', color)}>{label}</span>
    </span>
  );
}
